import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { createBrowserHistory } from "./helper/history";
import appUrls from './helper/appUrls';

const reactPlugin = new ReactPlugin();
const browserHistory = createBrowserHistory({ basename: "" });

const appInsights = new ApplicationInsights({
  config: {
    connectionString: appUrls.APP_INSIGHTS_CONNECTION_STRING,
    enableAutoRouteTracking: true,    // automatically track route changes
    extensions: [reactPlugin],        // attach React plugin

    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory }   // Configure React plugin with browser history
    },

    enableCorsCorrelation: true,      // enable frontend-backend correlation
    distributedTracingMode: 2         // enable frontend-backend correlation
  }
});

appInsights.loadAppInsights();        // load the Application Insights sdk

appInsights.addTelemetryInitializer((envelope) => {
  envelope.tags["ai.cloud.role"] = "react-frontend";
});


appInsights.trackPageView();          // track initial page load



export { appInsights, reactPlugin };